import {
  Component,
  Input,
  SimpleChanges,
  forwardRef,
  Output,
  EventEmitter,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { EoDropdownComponent } from 'ngx-eo-web-components';
import { STATUS } from '../../../core/models/loading-status.enum';
import { HospitalUser } from '../../../core/models/hospital-user.model';
import { HospitalUserService } from '../../../../services/hospital-user/hospital-user.service';

@Component({
  selector: 'app-hospital-user-dropdown',
  templateUrl: './hospital-user-dropdown.component.html',
  styleUrls: ['./hospital-user-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => HospitalUserDropdownComponent),
      multi: true,
    },
  ],
})
export class HospitalUserDropdownComponent extends EoDropdownComponent<HospitalUser> {
  @Input() override label = 'Διαχειριστής';
  @Input() override optionLabel = 'fullName';
  @Input() override optionValue = 'id';
  @Input() override placeholder = 'Όλοι οι χρήστες';
  @Input() override filterPlaceholder = 'Αναζήτηση με ονοματεπώνυμο';
  @Input() override filterBy = 'fullName';
  @Input() role?: string | null;

  override options: HospitalUser[] = [];
  hospitalUserListCallHandler =
    this.hospitalUserService.hospitalUserListCallHandler;

  @Input() hospitalId?: string | null;

  constructor(private readonly hospitalUserService: HospitalUserService) {
    super();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['hospitalId']) {
      const newValue = changes['hospitalId'].currentValue;
      if (!newValue) {
        this.clearOptions(); // Clear options if hospitalId is cleared
      } else {
        this.getHospitalUsers(); // Fetch hospital-users if hospitalId is provided
      }
    }
  }

  override ngOnInit() {
    this.getHospitalUsers();
  }

  getHospitalUsers() {
    if (!this.hospitalId) {
      this.clearOptions(); // Clear options if no hospital ID is provided
      return;
    }
  
    const fetchUsers = () => {
      const request = this.role
        ? this.hospitalUserService.getHospitalUsersByHospitalAndRole(this.hospitalId!, this.role!)
        : this.hospitalUserService.getHospitalUsersByHospital(this.hospitalId!);
  
      request.subscribe((data) => {
        this.options = data;
      });
    };
  
    fetchUsers();
  }
  

  clearOptions() {
    this.options = [];
  }

  override hasFilter(): boolean {
    return true;
  }

  override isLoading(): boolean {
    return (
      this.hospitalUserListCallHandler.status$.getValue() === STATUS.loading
    );
  }
}
